import React from "react";
import { Box, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { useTranslation } from "react-i18next";
import { NJIM } from "../../theme/njimTheme";

interface EmptyStateProps {
  icon?: React.ReactNode;
  title?: string;
  description?: string;
  action?: React.ReactNode;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  action,
}) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        textAlign: "center",
        py: { xs: 5, sm: 7 },
        px: 2,
        gap: 1.25,
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: "16px",
          display: "grid",
          placeItems: "center",
          bgcolor: NJIM.mintWash,
          color: NJIM.ink,
          mb: 0.5,
        }}
      >
        {icon ?? <InboxOutlinedIcon sx={{ fontSize: 26 }} />}
      </Box>
      <Typography sx={{ fontSize: 16, fontWeight: 600, color: NJIM.ink }}>
        {title ?? t("ui.emptyTitle")}
      </Typography>
      <Typography sx={{ fontSize: 14, color: NJIM.textSecondary, maxWidth: 360 }}>
        {description ?? t("ui.emptyDescription")}
      </Typography>
      {action}
    </Box>
  );
};

export default EmptyState;
